import React from "react";
import "./Track.css";
import Cartificate from "../../../img/Packages/cartificate.svg";
import Micro from "../../../img/Packages/micro.svg";
import Play from "../../../img/Packages/play.svg";
import QA from "../../../img/Packages/qa.svg";
import Slack from "../../../img/Packages/slack.svg";

const Track = (props) => {
    const pageLink = window.location.href.toString();
    const indexUtm = pageLink.indexOf('?');
    const utm = pageLink.slice(indexUtm + 1);

    return (
        <div className={`track ${props.track.trackDesc === '1' ? 'active' : 'non-active'}`}>
            <h3 className='trackTitle'>{props.track.trackTitle}</h3>
            <h3 className='trackTitle-num'>{props.track.trackDesc === '1' ? 'Talks #11 - #24' : 'Talks #1 - #10'}</h3>
            <p className='trackSubtitle p1'>{props.track.trackSubtitle}</p>
            <p className='p1'>{props.track.data}</p>
            {props.track.trackDesc &&
                <>
                    <div className='trackPrice trackPrice--active'>
                        {/* <div className='packages_price--full_block'>
                            <p className='packages_price--full'>$500</p>
                            <p className='packages_price--full_desc'>full price</p>
                        </div> */}
                        <div>
                            <p className='packages_price'>$500</p>
                            {/* <p className='packages_price--desc'>early bird</p> */}
                        </div>
                        {/* <div className='packages_price--save_block'>
                            <p className='packages_price--save_desc'>save</p>
                            <p className='packages_price--save'>${500 - 399}</p>
                        </div> */}
                    </div>
                </>}
            {!props.track.trackDesc && <p className={`trackPrice ${props.track.trackDesc === '1' ? 'active' : ''}`}>$0 <span>free attendance</span></p>}
            <span className="track_running_string--span"> What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included · What’s included ·</span>
            <div className={`trackDesc ${props.track.trackDesc === '1' ? 'active' : ''}`}>
                <div className='trackDesc_item trackDesc_second p1'>
                    <img src={Micro} alt="track_micro" />
                    <p>Junior Track Access</p>
                </div>
                <div className='trackDesc_item trackDesc_second p1'>
                    <img src={QA} alt="track_qa" />
                    <p>{props.track.trackQA ? props.track.trackQA : 'Live Q&A panels'}</p>
                </div>
                <div className='trackDesc_item trackDesc_first p1'>
                    <img src={Micro} alt="track_micro" />
                    <p>{props.track.trackDesc !== '1' && 'No'} Pro Track Access</p>
                </div>
                <div className='trackDesc_item trackDesc_first p1'>
                    <img src={Play} alt="track_play" />
                    <p>{props.track.trackFull ? props.track.trackFull : 'No On-demand recordings of both tracks'}</p>
                </div>
                <div className='trackDesc_item trackDesc_fourth p1'>
                    <img src={Slack} alt="track_slack" />
                    <p>{props.track.trackDesc !== '1' && 'No'} Slack membership</p>
                </div>
                <div className='trackDesc_item trackDesc_fifth p1'>
                    <img src={Cartificate} alt="track_cartificate" />
                    <p>{props.track.trackDesc !== '1' && 'No'} Certificate of attendance</p>
                </div>
            </div>
            <a className='button track_btn' target='_blank' rel='noreferrer' href={`${props.track.trackLink}?page=angular2${indexUtm !== -1 ? `&${utm}` : ''}`}>{props.track.trackButton}</a>
        </div>
    );
};

export default Track;